/**
 * TanStack Query hooks for `chartboost-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	stats,
	chartboostIntegrationQueryKeys,
	type CreateChartboostIntegrationBody,
	type CreateChartboostIntegrationResponse,
	type ListChartboostIntegrationResponse,
	type ChartboostIntegrationStats,
} from "./api";

export function useChartboostIntegrationList(filters?: {
	event_name?: string;
	network_app_id?: string;
}): UseQueryResult<ListChartboostIntegrationResponse, Error> {
	return useQuery({
		queryKey: chartboostIntegrationQueryKeys.list(filters),
		queryFn: () => list(filters),
	});
}

export function useChartboostIntegrationStats(): UseQueryResult<
	ChartboostIntegrationStats,
	Error
> {
	return useQuery({
		queryKey: chartboostIntegrationQueryKeys.stats(),
		queryFn: stats,
	});
}

export function useChartboostIntegrationCreate(): UseMutationResult<
	CreateChartboostIntegrationResponse,
	Error,
	CreateChartboostIntegrationBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: chartboostIntegrationQueryKeys.all });
		},
	});
}
